export const experienceData = [
    {
        id: 1,
        company: 'Self Employed',
        jobtitle: 'Freelance Web Developer',
        startYear: '2021-Present',

    },
    {
        id: 2,
        company: 'Eulogik',
        jobtitle: 'Software Egineer Intern',
        startYear: '2021 (2 months)',
    },
]


//schema for entering the data

    // {
    //     id: 3,
    //     company: '',
    //     jobtitle: '',
    //     startYear: '',
    //     endYear: ''
    // },